<template>
  <div id="app">
    <div>
      <Header />
    </div>
    <router-view />
    <div>
      <Footer />
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "App",
  components: {
    Header,
    Footer
  }
};
</script>

<style>
#app {
  background-color: #c2cad0;
  font-family: sans-serif;
}

a:link {
  text-decoration: none;
}

h1 {
  font-size: 3.2vw;
}
</style>
